import { supabase } from './supabase';

/**
 * The bug icon (Gary, 19 Oct): a report or an idea goes to the Feedback channel in Team, for head office
 * (chats-feedback). The icon sits on the four main screens, so the screen the person was on before is sent
 * with it: the app notes every screen as it opens.
 */
const MAIN = ['/', '/team', '/drc', '/settings'];
let lastScreen = '';

export function noteScreen(path: string) {
  if (!MAIN.includes(path)) lastScreen = path;
}

export async function sendFeedback(kind: 'bug' | 'idea', text: string, photo: File | null): Promise<void> {
  const form = new FormData();
  form.set('kind', kind);
  form.set('text', text);
  const here = window.location.pathname + window.location.search;
  form.set('screen', lastScreen && lastScreen !== here ? `${here} (before: ${lastScreen})` : here);
  form.set('device', navigator.userAgent);
  form.set('version', document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/"]')?.src.split('/').pop() ?? '');
  if (photo) form.set('photo', photo);
  const { error } = await supabase.functions.invoke('chats-feedback', { body: form });
  if (error) {
    let message = 'That did not send. Try again.';
    try {
      const ctx = (error as { context?: Response }).context;
      const j = ctx ? await ctx.json() as { error?: string } : null;
      if (j?.error) message = j.error;
    } catch { /* keep the default message */ }
    throw new Error(message);
  }
}
